import React from "react";
import { Table, Alert, Spinner } from "react-bootstrap";
import { COLORS } from "../../types/profession.types";
import { ProfessionRow } from "./ProfessionRow";

interface PricingTableProps {
  professions: any[];
  edits: Record<number, any>;
  savingId: number | null;
  onEdit: (professionId: number, field: string, value: any) => void;
  onSave: (profession: any) => void;
  onDelete: (profession: any) => void;
}

export const PricingTable: React.FC<PricingTableProps> = ({
  professions,
  edits,
  savingId,
  onEdit,
  onSave,
  onDelete,
}) => {
  if (professions.length === 0) {
    return (
      <tr>
        <td colSpan={8} className="text-center p-4">
          <Alert variant="info" className="mb-0">
            Aucune profession ne correspond aux filtres sélectionnés.
          </Alert>
        </td>
      </tr>
    );
  }

  return (
    <div className="pricing-table-container">
      <div
        className="table-responsive"
        style={{ maxHeight: "calc(70vh - 120px)", overflowY: "auto", overflowX: "auto" }}
      >
        <Table striped bordered hover className="align-middle" style={{ marginBottom: 0, minWidth: "1200px" }}>
          {/* En-têtes fixes */}
          <thead style={{ position: "sticky", top: 0, zIndex: 100, backgroundColor: "white" }}>
            <tr>
              <th style={{ position: "sticky", top: 0, backgroundColor: COLORS.primary, zIndex: 101, minWidth: "200px", color: "white" }}>
                Profession
              </th>
              <th style={{ width: "100px", position: "sticky", top: 0, backgroundColor: COLORS.primary, zIndex: 101, color: "white" }} className="text-center">
                Prioritaire
              </th>
              <th style={{ width: "120px", position: "sticky", top: 0, backgroundColor: COLORS.primary, zIndex: 101, color: "white" }} className="text-center">
                Utilisateurs
              </th>
              <th style={{ width: "160px", backgroundColor: COLORS.primary, position: "sticky", top: 0, zIndex: 101, color: "white" }} colSpan={2} className="text-center">
                Premium
              </th>
              <th style={{ width: "160px", backgroundColor: COLORS.primary, position: "sticky", top: 0, zIndex: 101, color: "white" }} colSpan={2} className="text-center">
                Export
              </th>
              <th style={{ width: "160px", position: "sticky", top: 0, backgroundColor: COLORS.primary, zIndex: 101, color: "white" }} className="text-center">
                Actions
              </th>
            </tr>
            
            {/* Deuxième ligne d'en-tête */}
            <tr>
              <th style={{ position: "sticky", top: 41, backgroundColor: "#f8f9fa", zIndex: 100 }}></th>
              <th style={{ position: "sticky", top: 41, backgroundColor: "#f8f9fa", zIndex: 100 }}></th>
              <th style={{ position: "sticky", top: 41, backgroundColor: "#f8f9fa", zIndex: 100 }}></th>
              <th style={{ backgroundColor: "#fff4e6", position: "sticky", top: 41, zIndex: 100 }}>Prix (€)</th>
              <th style={{ backgroundColor: "#fff4e6", position: "sticky", top: 41, zIndex: 100 }}>Places</th>
              <th style={{ backgroundColor: "#e6f7ff", position: "sticky", top: 41, zIndex: 100 }}>Prix (€)</th>
              <th style={{ backgroundColor: "#e6f7ff", position: "sticky", top: 41, zIndex: 100 }}>Statut</th>
              <th style={{ position: "sticky", top: 41, backgroundColor: "#f8f9fa", zIndex: 100 }}></th>
            </tr>
          </thead>
          
          <tbody>
            {professions.map((profession) => (
              <ProfessionRow
                key={profession.id}
                profession={profession}
                edit={edits[profession.id] || {}}
                isSaving={savingId === profession.id}
                onEdit={(field, value) => onEdit(profession.id, field, value)}
                onSave={() => onSave(profession)}
                onDelete={() => onDelete(profession)}
              />
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};